import { apiClient } from '../../lib/api-client';
import type { DashboardSummaryResponse } from './types';

export const fetchDashboardSummary = async () => {
  const response = await apiClient.get<DashboardSummaryResponse>('/dashboard/summary');
  return response.data.data;
};
